import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-see-group-detail',
  templateUrl: './see-group-detail.component.html',
  styleUrls: ['./see-group-detail.component.scss']
})
export class SeeGroupDetailComponent {

  constructor(
    private dialoRef:MatDialogRef<SeeGroupDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { name: string }
  ){

  }



}
